<!--
 * @Author: 'llhj' llhj0326@163.com
 * @Date: 2024-02-23 10:20:35
 * @LastEditors: 'llhj' llhj0326@163.com
 * @LastEditTime: 2024-06-25 17:07:45
 * @FilePath: \front\src\views\Patient\components\prescription\sendDialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  
  <el-dialog
			title="推送处方"
			:visible.sync="visible"
			width="32%"
			:close-on-click-modal="false"
            :before-close='closedialog'
            :modal="true"
			>
			<div style="text-align: center;">
				您确定将{{
                    info[type]
                }}推送至双佰康小程序？<br/>
                推送成功后，患者将能够在双佰康小程序中查看{{ info[type] }}。
			</div>
			
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="sendHandle">确定推送</el-button>

				<el-button @click="closedialog">取 消</el-button>
			</span>
		</el-dialog>
</template>

<script>
	import api from '@/service/api.js';
    import { EventBus } from '@/event-bus.js';

export default {
    props:{
        dialogVisible:{
            type:Boolean,
        },
        type:{
            type:String,
        },
        prescriptionId:{
            required:true,
        }
    },
    data(){
        return{
            visible:true,
            info:{
                '1':'用药处方',
                '6':'中医处方',
                '2':'饮食处方',
                '4':'心理处方',
                '5':'睡眠处方',
                '3':'运动处方',
            }
        }
    },
    created(){
        console.log(this.prescriptionId,'’=========sthis.prescriptionId') 
    },
    methods:{
        async sendHandle(){
            if(!this.prescriptionId)return;
            let res=await api.pushPrescription({
                prescriptionId:this.prescriptionId,
                prescriptionType:this.type
            });
            if(res.code==1000){
                this.$message.success('推送成功');
                EventBus.$emit('trigger-event',this.type);
            } else{
                this.$message.error('推送失败');

            }
            this.$emit("update:dialogVisible", false);

        },
        closedialog(){
			this.$emit("update:dialogVisible", false);

        }
    }
}
</script>

<style>

</style>